/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountDeletionTaskStatRatio
 */
export interface AccountDeletionTaskStatRatio {
    /**
     * 
     * @type {number}
     * @memberof AccountDeletionTaskStatRatio
     */
    value?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountDeletionTaskStatRatio
     */
    ratioAsPercent?: number;
}

/**
 * Check if a given object implements the AccountDeletionTaskStatRatio interface.
 */
export function instanceOfAccountDeletionTaskStatRatio(value: object): value is AccountDeletionTaskStatRatio {
    return true;
}

export function AccountDeletionTaskStatRatioFromJSON(json: any): AccountDeletionTaskStatRatio {
    return AccountDeletionTaskStatRatioFromJSONTyped(json, false);
}

export function AccountDeletionTaskStatRatioFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountDeletionTaskStatRatio {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'ratioAsPercent': json['ratioAsPercent'] == null ? undefined : json['ratioAsPercent'],
    };
}

export function AccountDeletionTaskStatRatioToJSON(value?: AccountDeletionTaskStatRatio | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'ratioAsPercent': value['ratioAsPercent'],
    };
}

